<template>
  <v-container fluid>
    <v-row class='mt-1'>
      <div class='header mt-0'>
        <h2>Статистика</h2>
      </div>
      <div class='horizontal-rule mb-2' />

      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Образцов: {{ examplesCount }}
        </v-card>
      </v-col>

      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Сканов: {{ scansCount }}
        </v-card>
      </v-col>

      <v-col sm='4' class='pa-0'>
        <v-card tile class='pa-2'>
          Видов: {{ speciesCount }}
        </v-card>
      </v-col>


    </v-row>


    <v-row class='mt-8'>
      <div class='header mt-0'>
        <h2>Поиск</h2>
      </div>
      <div class='horizontal-rule mb-2' />

      <h4>Выберите группу образцов</h4>

      <v-tabs>
        <v-tab @click='changePlantTypePlant'>Высшие растения</v-tab>
        <v-tab @click='changePlantTypeLichen'>Лишайники</v-tab>
      </v-tabs>
      <SearchComponent
        class='pa-2 mt-2'
        @filter='onFilter'
        @find='onFind'
      />
    </v-row>

    <v-row class='mt-8 mb-3' v-show='wasSearched'>
      <v-col class='pa-0'>
        <TableComponent
          :plants='this.plants'
          :page='actualPage'
          :max-page='maxPage'
          @nextPage='changePage'
          @previousPage='changePage'
          @changePage='changePage'
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchComponent from '@/components/SearchComponent';
import TableComponent from '@/components/TableComponent';
import { fetchExhibits, fetchStatisticsExhibit } from '@/services/exhibitAPI';

export default {
  name: 'HomePage',
  components: { TableComponent, SearchComponent },

  data() {
    return {
      examplesCount: 0,
      scansCount: 0,
      speciesCount: 0,

      filterData: {
        genusQuery: '',
        barcodeQuery: '',
        gatheringPlaceRegionQuery: '',
        gatheringPlaceDistrictQuery: '',
        gatheringPlaceCountryQuery: '',
      },

      wasSearched: true,
      plantType: 'HIGHER_PLANT',

      plants: [],

      page: 0,
      maxPage: 0,
    };
  },

  computed: {
    actualPage() {
      return this.page;
    },
  },

  mounted() {
    this.getStatistic();
    this.onFind(this.filterData, false);
  },

  methods: {
    onFilter(filterData) {
      this.filterData = filterData;
    },

    changePlantTypePlant() {
      this.plantType = 'HIGHER_PLANT';
      this.plants = [];
    },

    changePlantTypeLichen() {
      this.plantType = 'LICHEN';
      this.plants = [];
    },

    changePage(e) {
      this.page = e;
    },

    async getStatistic() {
      const statistic = (await fetchStatisticsExhibit()).result;
      this.examplesCount = statistic.exhibitsCount;
      this.scansCount = statistic.exhibitsPhotosCount;
      this.speciesCount = statistic.speciesCount;
    },

    async onFind(filterData, rollBackPage = true) {

      if (rollBackPage) {
        this.page = 0;
      }

      await fetchExhibits(filterData, this.page, this.plantType)
        .then((data) => {
          this.maxPage = data.maxPage;
          this.plants = data.body;
          this.wasSearched = true;
        })
        .catch((e) => {
          this.wasSearched = false;
          this.plants = [];
        });
    },

  },

  watch: {
    page() {
      this.onFind(this.filterData, false);
    },
    plantType() {
      this.onFind(this.filterData);
    }
  },
};
</script>

<style scoped>

</style>`